import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from '../finance/shared';

const TransportCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [transportType, setTransportType] = useState('car');
  const [distance, setDistance] = useState('20');
  const [efficiency, setEfficiency] = useState('10');
  const [fuelPrice, setFuelPrice] = useState('6,00');
  const [people, setPeople] = useState('1');
  const [frequency, setFrequency] = useState('daily');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const dist = parseFloat(parseBrazilianNumber(distance)) || 0;
    const eff = parseFloat(parseBrazilianNumber(efficiency)) || 1;
    const price = parseFloat(parseBrazilianNumber(fuelPrice)) || 0;
    const numPeople = parseInt(people) || 1;

    if (dist <= 0 || price <= 0) return;

    const multipliers: any = { car: 1, motorcycle: 0.4, bus: 0.3, uber: 1.8 };
    const multiplier = multipliers[transportType] || 1;

    const fuelCost = (dist / eff) * price * multiplier;
    const totalCost = fuelCost; // Simplificado para modularização rápida
    const freqMultipliers: any = { daily: 30, weekly: 4, monthly: 1 };
    const monthlyCost = totalCost * (freqMultipliers[frequency] || 1);

    setResultState({ totalCost, monthlyCost });
    onResultChange([
      { label: 'Custo Viagem', value: `R$ ${totalCost.toFixed(2)}` },
      { label: 'Custo Mensal', value: `R$ ${monthlyCost.toFixed(2)}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <FormField label="Transporte" value={transportType} onChange={setTransportType} type="select" options={[{ value: 'car', label: 'Carro' }, { value: 'motorcycle', label: 'Moto' }, { value: 'bus', label: 'Ônibus' }]} />
          <FormField label="Distância (km)" value={distance} onChange={setDistance} isNumeric required type="text" />
          <FormField label="Preço Combustível" value={fuelPrice} onChange={setFuelPrice} isNumeric required type="text" />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:scale-[1.02] transition-all flex items-center gap-2">
            <Icon name="play" className="w-5 h-5" /> Calcular Custo
          </button>
        </div>
        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ResultCard title="Custo por Viagem" value={`R$ ${resultState.totalCost.toFixed(2)}`} color="indigo" />
            <ResultCard title="Custo Mensal Estimado" value={`R$ ${resultState.monthlyCost.toFixed(2)}`} color="emerald" />
          </div>
        )}
      </div>
    </div>
  );
};

export default TransportCalculator;
